import { find } from 'lodash';
import { AccountPlanName } from '@adjust/dashboard-core/api/types';
import { formatNumber, formatCurrency } from '@adjust/dashboard-core/lib/format/number';

import { Plan } from '@api/types';

export const getAttributions = (plan: Plan) => {
  if (plan.includedAttributions === -1) {
    return t('label.unlimited-with-asterisk');
  }

  return formatNumber(plan.includedAttributions);
};

export const getAttributionPrice = (attributionPrice: number, currency: string) =>
  attributionPrice === 0
    ? t('label.all-you-can-track-with-asterisk')
    : formatCurrency({ currency, maximumSignificantDigits: 3 })(attributionPrice);

export const getYearlySaving = (
  currency: string,
  attributionPrice: number,
  name: AccountPlanName,
  monthlyPaymentPlans: Plan[],
) => {
  const monthlyPaymentPlan = find(monthlyPaymentPlans, { name });

  if (!monthlyPaymentPlan) {
    return '';
  }

  const percent = monthlyPaymentPlan.attributionPrice - attributionPrice;

  return percent > 0
    ? t('pricing-plan.save-money', {
        money: formatCurrency({ currency, maximumSignificantDigits: 3 })(percent),
      })
    : '';
};

export const getBasePrice = (currency: string, basePrice: number) =>
  formatCurrency({ currency, minimumFractionDigits: 0 })(basePrice);

export const getAttributionSaving = (plan: Plan, monthlyPaymentPlans: Plan[]) => {
  const monthlyPaymentPlan = find(monthlyPaymentPlans, { name: plan.name });

  if (!monthlyPaymentPlan) {
    return '';
  }

  if (plan.flat) {
    const percent = Math.round(((monthlyPaymentPlan.basePrice - plan.basePrice) / monthlyPaymentPlan.basePrice) * 100);

    return percent > 0 ? t('pricing-plan.save-money-in-percent', { percent }) : '';
  }

  const percent = Math.round(
    ((plan.includedAttributions - monthlyPaymentPlan.includedAttributions) / monthlyPaymentPlan.includedAttributions) *
      100,
  );

  return percent > 0
    ? t('pricing-plan.save-attributions-in-percent', {
        percent,
      })
    : '';
};
